exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".vc-mutil-checkbox .checkbox-item[data-v-8ba00ef6]{margin-right:20px}", ""]);

// exports
